<script>
    import { blur } from 'svelte/transition';
    import { quintIn } from 'svelte/easing';
</script>

<svelte:head>
	<title>PotatoSites | 404</title>
</svelte:head>

<section class="container grid-lg">
    <div class="columns">
        <div class="column col-12" in:blur="{{ duration: 500, easing: quintIn }}">
            <h2 class="text-center text-uppercase">404 | Page not found</h2>

            <div class="d-flex page_404">
                <div class="page_404__img">
                    <svg version="1.1" class="svg_icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve">
                        <style type="text/css">
                            .fill_white{stroke-width:6;stroke-miterlimit:10;}
                        </style>
                        <circle class="fill_black" cx="100" cy="100" r="100"/>
                        <g>
                            <path class="fill_white" d="M67.1,109.3h6.6v5.4h-6.6v8.7h-6v-8.7H33.8l33.3-47.5V109.3z M61.1,109.3v-24l-16.8,24H61.1z"/>
                            <path class="fill_white" d="M100.4,69.2c5.4,0,10,2.6,13.6,7.8c3.6,5.2,5.4,11.8,5.4,19.7c0,7.8-1.8,14.3-5.5,19.6
                                c-3.7,5.3-8.2,7.9-13.6,7.9c-5.3,0-9.8-2.6-13.5-7.9c-3.7-5.3-5.5-11.8-5.5-19.6c0-7.7,1.8-14.3,5.5-19.6
                                C90.4,71.8,95,69.2,100.4,69.2z M100.3,74.6c-3.7,0-6.8,2.1-9.4,6.4c-2.6,4.2-3.8,9.4-3.8,15.6c0,6.4,1.2,11.7,3.7,15.9
                                c2.5,4.2,5.6,6.3,9.4,6.3c3.8,0,7-2.1,9.5-6.3c2.6-4.2,3.8-9.5,3.8-15.8c0-6.3-1.3-11.5-3.8-15.7C107.2,76.7,104.1,74.6,100.3,74.6
                                z"/>
                            <path class="fill_white" d="M157.2,109.3h6.6v5.4h-6.6v8.7h-6v-8.7h-27.3l33.3-47.5V109.3z M151.2,109.3v-24l-16.8,24H151.2z"/>
                        </g>
                        </svg>

                </div>
            </div>
        </div>
        
    </div>
</section>

<style lang="scss">
    .page_404{
        justify-content: center;
        align-items: center;
        flex-direction: column;
        &__img{
            margin-top: 5rem;
            max-width: 120px;
            margin-bottom: 1.5rem;
            > svg{
                width: 100%;
                height: 100%;
            }
        }
    }
</style>